export default __webpack_public_path__ + "static/media/background.02c632f5.jpg";